import React from "react";

export default React.createClass({
    render: function(){
        return(
            <div id={this.props.field + "-group"} className="form-div row">
              <div className={this.props.bigLabel ? "col-sm-7" : "col-sm-4"}>
                <label htmlFor={this.props.field}>{this.props.label}
                {this.props.requiredField &&
                  <span className="requiredField"> * </span>
                }
                </label>
              </div>
              <div className={this.props.bigLabel ? "col-sm-5" : "col-sm-8"}>
                {this.props.requiredField &&
                  <textarea name={this.props.field} id={this.props.field} required rows={this.props.rows} placeholder={this.props.placeholder}>{this.props.initialValue}</textarea>
                }
                {!this.props.requiredField &&
                  <textarea name={this.props.field} id={this.props.field} rows={this.props.rows} placeholder={this.props.placeholder}>{this.props.initialValue}</textarea>
                }

              </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/js/components/elements/text-area-row.jsx